export const CHROME_COMPANION_PROTOCOL_VERSION = 1
export const CHROME_COMPANION_READY_MESSAGE_TYPE = 'residesk:chrome-companion-ready'
export const CHROME_COMPANION_CONTEXT_MESSAGE_TYPE = 'residesk:chrome-companion-context'

export const CHROME_COMPANION_NEUTRAL_CONTEXT = Object.freeze({ status: 'neutral' })

export const isChromeExtensionOrigin = (origin = '') =>
  /^chrome-extension:\/\/[a-p]{32}$/.test(origin)

/**
 * Accept only the neutral version-one envelope.
 *
 * Page-derived identifiers require a new protocol version, matching Chrome
 * permissions, and server-side authorization. Unknown fields are rejected so
 * this transport cannot silently start carrying browser-page data.
 */
export const getChromeCompanionContextFromMessage = (data) => {
  if (
    data?.type !== CHROME_COMPANION_CONTEXT_MESSAGE_TYPE
    || data?.version !== CHROME_COMPANION_PROTOCOL_VERSION
    || data?.context?.status !== CHROME_COMPANION_NEUTRAL_CONTEXT.status
    || Object.keys(data).length !== 3
    || Object.keys(data.context).length !== 1
  ) {
    return null
  }

  return CHROME_COMPANION_NEUTRAL_CONTEXT
}
